import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LinearProgress, Stack, Typography } from "@mui/material";
/** goal completion scales through the standard error → warning → success ramp */ const severity = (rate)=>rate < 75 ? 'error' : rate < 95 ? 'warning' : 'success';
export const TrackRate = (props)=>{
    const rate = props.rate ?? 0;
    return /*#__PURE__*/ _jsxs(Stack, {
        "data-testid": props['data-testid'],
        direction: "row",
        sx: {
            alignItems: 'center',
            gap: 1,
            height: '100%',
            width: '100%'
        },
        children: [
            /*#__PURE__*/ _jsx(LinearProgress, {
                color: severity(rate),
                sx: (theme)=>({
                        backgroundColor: theme.palette.grey[300],
                        borderRadius: 1,
                        flex: '0 0 70%',
                        height: 8
                    }),
                value: Math.min(Math.max(rate, 0), 100),
                variant: "determinate"
            }),
            /*#__PURE__*/ _jsxs(Typography, {
                component: "span",
                variant: "body2",
                children: [
                    Math.round(rate),
                    "%"
                ]
            })
        ]
    });
};
TrackRate.displayName = 'TrackRate';

//# sourceMappingURL=TrackRate.js.map